// Size chart CM/Inch toggle
document.addEventListener('click', function(e) {
  if (e.target && e.target.closest('#size-toggle-btn')) {
    var cmTable = document.getElementById('table-cm');
    var inTable = document.getElementById('table-in');
    var knob = document.getElementById('size-toggle-knob');
    var labelCm = document.getElementById('label-cm');
    var labelIn = document.getElementById('label-in');
    var sizeIsCM = cmTable.style.display !== 'none';
    cmTable.style.display = sizeIsCM ? 'none' : 'block';
    inTable.style.display = sizeIsCM ? 'block' : 'none';
    knob.style.left = sizeIsCM ? '2px' : '26px';
    labelCm.style.color = sizeIsCM ? '#999' : '#222';
    labelIn.style.color = sizeIsCM ? '#222' : '#999';
  }
});
